import { ReactNode, useContext } from 'react'
import { CalculatorSolarContext } from 'context/CalculatorSolarContext'

import { MultiStep } from './MultiStep'
import classNames from 'classnames'

interface FormContainerProps {
  children: ReactNode
  headingLevel?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p'
}

export const FormContainer = ({
  children,
  headingLevel
}: FormContainerProps) => {
  const { steps, currentStep } = useContext(CalculatorSolarContext)
  const Heading = headingLevel || 'h1'

  return (
    <div
      id="simulation"
      className={classNames(
        'w-full bg-v3-gray-75 p-4 md:p-3 md:rounded-2xl',
        'h-fit md:h-full',
        'overflow-visible',
        '',
        {
          'xl:pt-5': currentStep === 'resumo'
        }
      )}
    >
      <div className="w-full h-full flex flex-col">
        <Heading className="text-[1.75rem] leading-9 font-semibold text-v3-gray-300 text-center xl:text-xl xl:leading-none 1.5xl:text-[1.75rem] xl:mb-1">
          Calculadora Solar
        </Heading>

        <p className="text-xs leading-[0.875rem] text-v3-gray-300 text-center lg:text-xs xl:text-[0.625rem] xl:leading-[0.875rem] 1.5xl:text-xs 1.5xl:leading-[0.875rem]">
          Economize{' '}
          <span className="font-semibold">até 35% na sua conta de luz</span>
        </p>

        <div className="mt-3">
          <MultiStep steps={steps} currentStep={currentStep} />
        </div>

        {/* Conteúdo do formulário */}
        <div
          className={classNames(
            'w-full flex-1 bg-white rounded-lg',
            // espaçamentos
            'py-4 px-[15.5px] lg:py-4 lg:px-8 xl:pt-3 xl:pb-2 xl:px-[15.5px] 1.5xl:px-8 1.5xl:py-4',
            // no mobile, se crescer, rola aqui dentro ao invés de cortar
            'overflow-y-auto md:overflow-visible'
          )}
        >
          {children}
        </div>
      </div>
    </div>
  )
}
